import { z } from "zod";

const SortOrder = z.enum(["asc", "desc"]);
export type SortOrder = z.infer<typeof SortOrder>;

const SortBy = z.enum([
    "name",
    "eventDate",
    "creationDate",
    "deadline",
    "ticketNumber",
    "membershipTrialExpiry",
    "mentionCreatedAt",
    "mentionDueDate",
    "activeRequests",
    "messageByMember",
    "messageByAgent",
    "lastSeenOnline",
]);
export type SortBy = z.infer<typeof SortBy>;

export function isSortBy(possible: unknown): possible is SortBy {
    return SortBy.safeParse(possible).success;
}

export function isSortOrder(possible: unknown): possible is SortOrder {
    return SortOrder.safeParse(possible).success;
}

export type SortSettings = {
    by: SortBy;
    order: SortOrder;
};
